import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ColumnSettings, LoadDataEvent, PagedData, SabisGrid2Component } from 'sabis-grid2';
import { AppNotificationsService } from '../../../core/notifications/app-notifications.service';


@Component({
  selector: 'sca-crud-grid',
  templateUrl: './crud-grid.component.html',
  styleUrls: ['./crud-grid.component.scss']
})
export class CRUDGridComponent implements OnInit {
  @Input('idFieldName') idFieldName: string = '';
  @Input('suffixName') suffixName: string = '';
  @Input('columns') columns: ColumnSettings[] = [];
  @Input('dataLoader') dataLoader: (event: LoadDataEvent) => Observable<PagedData<any>> = (e) => of({ totalCount: 0, rows: [] });
  @Input('dataSaver') dataSaver: (newrecords: any[], modifiedRecors: any[]) => Observable<boolean> = () => of(false);

  @ViewChild('grid') grid!: SabisGrid2Component;

  public isLoading: boolean = true;
  public isSaving: boolean = false;

  private _newRecords: any[] = [];
  private _modifiedRecords: any[] = [];
  private _deletedIds: number[] = [];


  constructor(
    private _appNotification: AppNotificationsService,
  ) { }

  ngOnInit(): void { }

  public onAddClick(): void {
    var newRecord = {} as any;
    this.columns.forEach(c => {
      newRecord[c.field] = undefined;
    });
    this.grid.addNewRecord(newRecord);
    this._newRecords.push(newRecord);
  }

  public onSaveClick(): void {
    this.grid.closeOpenCell();

    this.dataSaver(this._newRecords, this._modifiedRecords).subscribe(r => {
      this._newRecords = [];
      this._modifiedRecords = [];
    });
  }

  public onDataChanged(event: any[]): void {
    // check if already tracked as modified here (track by _idFieldName)
    event.forEach(mr => {
      let exists = this._modifiedRecords.some(r => r[this.idFieldName] === mr[this.idFieldName]);

      if (!exists && mr[this.idFieldName]) {
        this._modifiedRecords.push(mr);
      }
    });
  }

  private validateForSave(): boolean {
    // name is required
    let missingName = this._newRecords.length > 0 && this._newRecords.some(r => !r.name || r.name.length === 0);
    missingName = missingName || (this._modifiedRecords.length > 0 && this._modifiedRecords.some(r => !r.name || r.name.length === 0));

    if (missingName) {
      this._appNotification.completeRequiredFieldMessage();
      return false;
    }

    return true;
  }
}
